import React, { useState } from "react";
import { Link } from "react-router-dom";
import MegaMenu from "./mega-menu/MegaMenu";
import MegaMenuMobile from "./mega-menu/MegaMenuMobile";
import raidenlogo from "../../assets/Logo/raiden-logo6.png";
import icon from "../../assets/images/icon/53.svg";
import Chat from "../../assets/Sub-component/Livechat";
const HeaderThree = () => {
  const [navbar, setNavbar] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 68) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener("scroll", changeBackground);

  return (
    <>
      <div
        className={
          navbar
            ? " theme-main-menu sticky-menu theme-menu-three bg-none fixed "
            : "theme-main-menu sticky-menu theme-menu-three bg-none"
        }
      >
        <div className="d-flex align-items-center justify-content-center">
          <div className="logo ">
            <Link to="/">
              <img src={raidenlogo} alt="brand logo " className="logo-w" />
            </Link>
          </div>
          <MegaMenuMobile />

          <nav id="mega-menu-holder" className="navbar navbar-expand-lg">
            <div className="container nav-container">
              <div
                className="navbar-collapse collapse"
                id="navbarSupportedContent"
              >
                <div className="d-lg-flex justify-content-between align-items-center">
                  <MegaMenu />

                  <ul className="right-widget user-login-button d-flex align-items-center justify-content-center">
                    <li>
                      <Link
                        to="/contactus"
                        className="signUp-action d-flex align-items-center"
                      >
                    
                        <span>Getting Started</span>
                        <img src={icon} alt="icon" />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default HeaderThree;
